module.exports = __webpack_public_path__ + "assets/images/artist4.f6f47dc8.png";